module.exports = __webpack_public_path__ + "img/resaizer_kv_w.7caccbf1.png";